import { graphql } from 'gatsby';

import { Spacing, StrapiSpacer } from '@mewa/ui';

import {
  ConfigType,
  ContentSectionItem,
  PossibleContentSections,
} from '../fragment-and-types';
import { ContentLivePreviewConfig } from '../live-preview/types';

export type SpacerData = {
  spacing: Spacing;
  strapi_component: typeof componentName;
};

export type SpacerPreviewData = SpacerData;

export const query = graphql`
  fragment SpacerFragment on STRAPI__COMPONENT_SHARED_SPACER {
    spacing
    strapi_component
  }
`;

const componentName = 'shared.spacer';

const isComponent = (
  section: PossibleContentSections,
): section is ContentSectionItem<SpacerData> =>
  section.strapi_component === componentName;

export const Component = (props: SpacerData) => {
  return <StrapiSpacer spacing={props.spacing} />;
};

export const config: ConfigType<SpacerData> = {
  Component,
  isComponent,
  componentName,
};

export const previewConfig: ContentLivePreviewConfig = {
  componentName,
  populationParams: {},
  mapProperties: (data) =>
    data.strapi_component === componentName ? data : null,
};
